export default __webpack_public_path__ + "static/media/EuclidSquare-Regular.5c5dedb1.woff";